import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './assets/TEMPO-Logo-Small.png'
import _imports_1 from './assets/smithsonian.png'


const _hoisted_1 = {
  key: 0,
  id: "introduction-overlay",
  class: "elevation-10 gradient-background"
}
const _hoisted_2 = { id: "intro-window-close-button" }
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-logos" }
const _hoisted_5 = { class: "intro-text mb-3" }
const _hoisted_6 = { id: "intro-bottom-controls" }
const _hoisted_7 = { id: "main-content" }
const _hoisted_8 = { class: "content-with-sidebars" }
const _hoisted_9 = { id: "logo-title" }
const _hoisted_10 = { class: "snackbar-alert-ul" }
const _hoisted_11 = ["data-date"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { id: "menu-area" }
const _hoisted_14 = {
  style: {"font-weight":"normal"},
  tabindex: "0",
  href: "https://www.cosmicds.cfa.harvard.edu/resources/tempo",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_15 = { id: "map-container" }
const _hoisted_16 = {
  id: "map-contents",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_17 = { id: "map" }
const _hoisted_18 = {
  id: "loading-circle-progress-container",
  class: "d-flex flex-column align-center justify-center ga-2"
}
const _hoisted_19 = {
  key: 0,
  id: "map-legend"
}
const _hoisted_20 = { id: "map-show-hide-controls" }
const _hoisted_21 = {
  id: "opacity-slider-container",
  class: "mt-5"
}
const _hoisted_22 = { class: "d-flex flex-row align-center justify-space-between" }
const _hoisted_23 = { class: "d-flex flex-row align-center justify-space-between" }
const _hoisted_24 = { class: "d-flex flex-row align-center justify-space-between" }
const _hoisted_25 = { class: "d-flex flex-row align-center justify-space-between" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex flex-row align-center justify-space-between"
}
const _hoisted_27 = { id: "location-and-sharing" }
const _hoisted_28 = { id: "la-fires" }
const _hoisted_29 = { id: "slider-row" }
const _hoisted_30 = { class: "thumb-label" }
const _hoisted_31 = { id: "user-options" }
const _hoisted_32 = { id: "all-dates" }
const _hoisted_33 = { class: "d-flex flex-row align-center" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "d-flex flex-row align-center my-2" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { id: "date-radio" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 0,
  style: {"border-color":"grey"}
}
const _hoisted_41 = {
  key: 1,
  id: "locations-of-interest"
}
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { id: "bottom-options" }
const _hoisted_44 = { id: "information" }
const _hoisted_45 = { class: "d-flex flex-row justify-space-between" }
const _hoisted_46 = { id: "body-logos" }
const _hoisted_47 = { id: "user-experience-footer" }

import { ref, computed, watch, onMounted, nextTick, ComputedRef } from "vue";
import { API_BASE_URL, blurActiveElement, type UserExperienceRating } from "@cosmicds/vue-toolkit";
import { useDisplay } from 'vuetify';
import { DatePickerInstance } from "@vuepic/vue-datepicker";
import { v4 } from "uuid";
import { getTimezoneOffset } from "date-fns-tz";
import { cbarNO2 } from "./revised_cmap";
import { MapBoxFeature, MapBoxFeatureCollection, geocodingInfoForSearch } from "./mapbox";
import { _preloadImages } from "./PreloadImages";
import changes from "./changes";
import { useBounds } from './composables/useBounds';
import { interestingEvents } from "./interestingEventsAsList";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { LatLngPair, LngLatPair, InitMapOptions } from "./types";

import { useUniqueTimeSelection } from "./composables/useUniqueTimeSelection";


// Import Leaflet Composables
import { useMap } from "./composables/leaflet/useMap";
import { usezoomhome} from './composables/leaflet/useZoomHome';
import { useImageOverlay } from "./composables/leaflet/useImageOverlay";
import { useFieldOfRegard} from "./composables/leaflet/useFieldOfRegard";
import { useLocationMarker } from "./composables/leaflet/useMarker";
import { getTimestamps, getExtendedRangeTimestamps } from "./timestamps";

const zoomScale = 1; 

// const zoomScale = 0.5; // for matplibre-gl


type SheetType = "text" | "video" | null;
type Timeout = ReturnType<typeof setTimeout>;


/**************
 * UI Setup
 *************/
// const hash = window.location.hash;
const showExtendedRangeFeatures = true; //hash.includes("extreme-events");
const OPT_OUT_KEY = "tempo-lite-optout" as const;
const RATING_OPT_OUT_KEY = "tempo-lite-optout" as const;

const UUID_KEY = "tempo-lite-uuid" as const;
const homeLat = 40.044;
const homeLon = -98.789;

export default /*@__PURE__*/_defineComponent({
  __name: 'TempoLite',
  setup(__props) {

const display = useDisplay();
const calendar = ref<DatePickerInstance | null>(null);
const urlParams = new URLSearchParams(window.location.search);
const showSplashScreen = ref(new URLSearchParams(window.location.search).get("splash")?.toLowerCase() !== "false");
const extendedRange = ref(window.location.hash.includes("extreme-events") || urlParams.get('extendedRange') === "true"); //showExtendedRangeFeatures || urlParams.get('extendedRange') === "true";
const hideIntro = urlParams.get("hideintro") === "true";
const WINDOW_DONTSHOWINTRO = hideIntro ? true : window.localStorage.getItem("dontShowIntro") === 'true';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore --> msPointerEnabled may not be defined in window.navigator
const touchscreen = ref(('ontouchstart' in window) || ('ontouchstart' in document.documentElement) || !!window.navigator.msPointerEnabled);



const STORY_VISIT_URL = `${API_BASE_URL}/tempo-lite/visit`;
function pingServer(venue: string) {

  fetch(STORY_VISIT_URL, {
    
    method: "POST",
    
    headers: {
      "Content-Type": "application/json",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Authorization": process.env.VUE_APP_CDS_API_KEY ?? ''
    },
    
    body: JSON.stringify({
      info: { venue }
    })
    
  })
    .then((response) => {
      if (!response.ok) {
        console.error("Error pinging server", response.status, response.statusText);
      } 
    }).
    catch((error) => {
      console.error("Error pinging server", error);
    });
}

const venue = (urlParams.get("venue") ?? '').replace(/,/g, '-');

if (venue !== '') {
  // get current value of venue
  const venues =  window.localStorage.getItem("venues") ?? '';
  // if they haven't visited this venue before, ping the server & save it
  if (!venues.includes(venue)) {
    pingServer(venue);
    window.localStorage.setItem("venues", venues ? `${venues},${venue}` : venue);
  }
}


function clearUrl(hash = false) {
  const newUrl = location.origin + location.pathname + (hash ? location.hash : '');
  window.history.replaceState({}, '', newUrl);
}
clearUrl(true);


const introSlide = ref(1);
const inIntro = ref(!WINDOW_DONTSHOWINTRO);
const dontShowIntro = ref(WINDOW_DONTSHOWINTRO);
const showNotice = ref(true);
const sheet = ref<SheetType>(null);
const accentColor = ref("#068ede");
const accentColor2 = ref("#ffcc33");

let hasOptOutBeenOpened = false;
const introductionOpen = computed(() => inIntro.value && (introSlide.value === 1));
const userGuideOpen = computed(() => inIntro.value && (introSlide.value === 4));

let whatsNewOpenedCount = 0;
let whatsNewTimestamp = null as number | null;
let whatsNewOpenTimeMs = 0;
let introductionOpenedCount = 0;
let introductionTimestamp = null as number | null;
let introductionOpenTimeMs = 0;
let userGuideOpenedCount = 0;
let userGuideTimestamp = null as number | null;
let userGuideOpenTimeMs = 0;
let aboutDataOpenedCount = 0;
let aboutDataTimestamp = null as number | null;
let aboutDataOpenTimeMs = 0;
let creditsOpenedCount = 0;
let creditsTimestamp = null as number | null;
let creditsOpenTimeMs = 0;
let shareButtonClickedCount = 0;
let playButtonClickedCount = 0;
let timeSliderUsedCount = 0;
let opacitySliderUsedCount = 0;
let fieldOfRegardToggled = false;
let cloudMaskToggled = false;
let hiResDataToggled = false;


let userSelectedCalendarDates: number[] = [];
let userSelectedTimezones: string[] = [];
let userSelectedLocations: string[] = [];
let userSelectedNotableEvents: [string, string][] = [];

const STORY_DATA_URL = `${API_BASE_URL}/tempo-lite/data`;
const STORY_RATING_URL = `${API_BASE_URL}/tempo-lite/user-experience`;
const storedRatingOptOut = window.localStorage.getItem(RATING_OPT_OUT_KEY);

const showRatingPrivacyPolicy = ref(false);
const question = Math.random() > 0.5 ? 
  "Does this spark your curiosity?" :
  "Are you learning something new?";
const currentRating = ref<UserExperienceRating | null>(null);
const currentComments = ref<string | null>(null);

const storedOptOut = window.localStorage.getItem(OPT_OUT_KEY);
const maybeUUID = window.localStorage.getItem(UUID_KEY);
const optOut = typeof storedOptOut === "string" ? storedOptOut === "true" : null;
const showPrivacyDialog = ref(false);
const responseOptOut = ref(optOut);

// If the user has opted out of all data collection, don't ask them the question
const ratingOptedOut = typeof storedRatingOptOut === "string" ? storedRatingOptOut === "true" : null;
const ratingOptOut = ref(responseOptOut.value || ratingOptedOut);
let ratingTimeout: ReturnType<typeof setTimeout> | null = null;
const showRating = ref(false);

const existingUser = maybeUUID !== null;
const uuid = maybeUUID ?? v4();
if (!existingUser) {
  window.localStorage.setItem(UUID_KEY, uuid);
}


function updateUserExperienceInfo(rating: UserExperienceRating | null, comments: string | null) {
  const body: Record<string, unknown> = {
    uuid,
    question,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    story_name: "tempo-lite",
  };
  if (rating) {
    body.rating = rating;
  }
  if (comments) {
    body.comments = comments;
  }
  fetch(STORY_RATING_URL, {
    method: "PUT",
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Authorization": process.env.VUE_APP_CDS_API_KEY ?? "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}



function clearRatingTimeout() {
  if (ratingTimeout !== null) {
    clearTimeout(ratingTimeout);
    ratingTimeout = null;
  }
}


function selectSheet(name: SheetType) {
  if (sheet.value === name) {
    sheet.value = null;
    nextTick(() => {
      blurActiveElement();
    });
  } else {
    sheet.value = name;
  }
}

const showTextSheet = computed({
  get() {
    return sheet.value === 'text';
  },
  set(_value: boolean) {
    selectSheet('text');
  }
});

const cssVars = computed(() => {
  return {
    '--accent-color': accentColor.value,
    '--accent-color-2': accentColor2.value,
    '--app-content-height': showTextSheet.value ? '66%' : '100%',
  };
});

const smallSize = computed(() => {
  return display.smAndDown.value;
});

const mobile = computed(() => {
  return smallSize.value && touchscreen.value;
});


function zpad(n: number, width: number = 2, character: string = "0"): string {
  return n.toString().padStart(width, character);
}

/************
 * TIMESTAMP SETUP
 ************/
const erdTimestamps = ref<number[]>([]);
const newTimestamps = ref<number[]>([]);
const cloudTimestamps = ref<number[]>([]);
const fosterTimestamps = ref<number[]>([
  1698838920000,
  1698841320000,
  1698843720000,
  1698846120000,
  1698848520000,
  1698852120000,
  1698855720000,
  1698859320000,
  1698862920000,
  1698866520000,
  1698870120000,
  1698873720000,
  1698876120000,
  1698878520000,
  1698880920000,
  1699011720000,
  1699014120000,
  1699016520000,
  1699018920000,
  1699021320000,
  1699024920000,
  1699028520000,
  1699032120000,
  1699035720000,
  1699039320000,
  1699042920000,
  1699046520000,
  1699048920000,
  1699051320000,
  1699053720000,
  1711626180000,
  1711628640000,
  1711631040000,
  1711633440000,
  1711637040000,
  1711640640000,
  1711644240000,
  1711647840000,
  1711651440000,
  1711655040000,
  1711658640000,
  1711662240000,
  1711665840000,
  1711668240000,
]);


const timestamps = ref<number[]>(fosterTimestamps.value);
const extendedRangeTimestamps = ref<number[]>([]);
const showExtendedRange = ref(extendedRange.value);
const useHighRes = ref(false);
const {
  timeIndex,
  timestamp,
  date,
  singleDateSelected,
  maxIndex,
  minIndex,
  uniqueDays,
  uniqueDaysIndex,
  setNearestDate,
  moveBackwardOneDay,
  moveForwardOneDay,
  nearestDateIndex } = useUniqueTimeSelection(timestamps);
  
const timeSliderIndex = computed({
  get() {
    return timeIndex.value;
  },
  set(value: number) {
    if (value > maxIndex.value) {
      return;
    }
    timeIndex.value = value;
  }
});

const timestampsLoaded = ref(false);
const fosterTimestampsSet = ref(new Set(fosterTimestamps.value));
const erdTimestampsSet = ref(new Set());
const newTimestampsSet = ref(new Set());
const cloudTimestampsSet = ref(new Set());
const extendedRangeTimestampsSet = ref(new Set());
const timestampsSet = ref(new Set(fosterTimestamps.value));

async function updateTimestamps() {
  return Promise.all([
    getExtendedRangeTimestamps().then(ts => {
      extendedRangeTimestamps.value = ts;
      extendedRangeTimestampsSet.value = new Set(ts);
    }),
    getTimestamps().then((ts) => {
      erdTimestamps.value = ts.early_release;
      erdTimestampsSet.value = new Set(ts.early_release);
      newTimestamps.value = ts.released;
      newTimestampsSet.value = new Set(ts.released);
      timestamps.value = timestamps.value.concat(erdTimestamps.value, newTimestamps.value).sort();
      timestampsSet.value = new Set(timestamps.value);
      cloudTimestamps.value = ts.clouds;
      cloudTimestampsSet.value = new Set(ts.clouds);
    })
  ]);
}

updateTimestamps().then(() => { timestampsLoaded.value = true; })
  .then(() => {
    if (window.location.hash.includes("extreme-events")) {
      nextTick(() => {
        activateExtremeEvents();
      });
    }
  });


/************
 * INITIAL LOCATIONS SETUP
 ************/


const initLat = parseFloat(urlParams.get("lat") || '40.044');
const initLon = parseFloat(urlParams.get("lon") || '-98.789');
const initZoom = parseFloat(urlParams.get("zoom") || `${4 * zoomScale}`); // 4 is the default zoom level for the map, multiplied by zoomScale for maplibre
const initTime = urlParams.get("t");
const initState = ref<InitMapOptions>({
  loc: [initLat, initLon] as LatLngPair,
  zoom: initZoom,
  t: initTime ? +initTime : null
});


const homeZoom = 4 * zoomScale; // 4 is the default zoom level for the map, multiplied by zoomScale for maplibre
const homeState = ref({
  loc: [homeLat, homeLon] as LatLngPair,
  zoom: homeZoom,
  t: null as number | null
});


const radio = ref<number | null>(null);
const sublocationRadio = ref<number | null>(null);


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { currentBounds: imageBounds } = useBounds(date);





const selectedTimezone = ref("US/Eastern");
const playing = ref(false);
const playInterval = ref<Timeout | null>(null);
const searchOpen = ref(true);
const searchErrorMessage = ref<string | null>(null);
const showControls = ref(false);
const showCredits = ref(false);
const showUserGuide = ref(false);
const showAboutData = ref(false);
const loadedImagesProgress = ref(0);

const showLocationMarker = ref(true);
const currentUrl = ref(window.location.href);
const showChanges = ref(false);
const showLADialog = ref(false);
const dataLagWarning = ref(false);


const imageName = computed(() => {
  return getTempoFilename(date.value);
});

const imageUrl = computed(() => {
  if (customImageUrl.value) {
    return customImageUrl.value;
  }
  const url = getTempoDataUrl(timestamp.value);
  if (url === null) { return ''; }
  return url + imageName.value;
});

const showClouds = ref(false);
const cloudUrl = computed(() => {
  if (!showClouds.value) {
    return '';
  }

  if (cloudTimestampsSet.value.has(timestamp.value)) {
    return getCloudFilename(date.value);
  }
  return '';
});


const opacity = ref(0.9);
const preload = ref(true);
const customImageUrl = ref("");
const cloudOverlay = useImageOverlay(cloudUrl, opacity, imageBounds, 'cloud-overlay');
const imageOverlay = useImageOverlay(imageUrl, opacity, imageBounds, 'image-overlay');

const cloudDataAvailable = computed(() => {
  return cloudTimestampsSet.value.has(timestamp.value);
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const whichDataSet = computed(() => {
  if (fosterTimestampsSet.value.has(timestamp.value)) {
    return 'TEMPO-lite';
  }

  if (erdTimestampsSet.value.has(timestamp.value)) {
    return 'Early Release (V01)';
  }

  if (newTimestampsSet.value.has(timestamp.value)) {
    return 'Level 3 (V03)';
  }

  return 'Unknown';
});


const highresAvailable = computed(() => {
  return newTimestampsSet.value.has(timestamp.value);
});

const extendedRangeAvailable = computed(() => {
  return extendedRangeTimestampsSet.value.has(timestamp.value);
});

const showingExtendedRange = computed(() => {
  return showExtendedRangeFeatures && showExtendedRange.value && extendedRangeAvailable.value;
});




const onMapReady = (map) => {
  map.on('moveend', updateURL);
  map.on('zoomend', updateURL);
};
const showRoads = ref(true);
const { map, createMap, setView } = useMap("map", initState.value, showRoads, onMapReady);

const { 
  addFieldOfRegard,
  showFieldOfRegard,
  updateFieldOfRegard 
} = useFieldOfRegard(singleDateSelected, map);

const {
  setMarker,
  removeMarker,
  locationMarker
} = useLocationMarker(map,  showLocationMarker.value);



onMounted(() => {
  window.addEventListener("hashchange", updateHash);
  showSplashScreen.value = false;
  createMap();

  usezoomhome(map, homeState.value.loc, homeState.value.zoom, (_e: Event) => {
    sublocationRadio.value = null;
    // check if location marker is not null and on map. if so remove it
    if (locationMarker.value !== null) {
      removeMarker();
    }
  });


  singleDateSelected.value = uniqueDays.value[uniqueDays.value.length - 1];
  if (map.value !== null) {
    imageOverlay.addTo(map.value); 
    cloudOverlay.addTo(map.value);
  }

  updateFieldOfRegard();
  addFieldOfRegard();

  createUserEntry();
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      updateUserData();
    } else {
      resetData();
    }
  });
  
});



const datesOfInterest = computed(() => {
  return interestingEvents.map(event => event.date);
});

const locationsOfInterest = computed(() => {
  return interestingEvents.map(event =>
    event.locations.map(loc => ({
      ...loc,
      index: nearestDateIndex(new Date(loc.time)),
    }))
  );
});

const locationsOfInterestText = computed(() => {
  return interestingEvents.map(event =>
    event.locations.map(loc => loc.description)
  );
});

const dateIsDST = computed(() => {
  const standardOffset = getTimezoneOffset(selectedTimezone.value, new Date(date.value.getUTCFullYear(), 0, 1));
  const currentOffset = getTimezoneOffset(selectedTimezone.value, date.value);
  if (standardOffset === currentOffset) {
    return false;
  }
  return true;
});

const timezoneOptions = computed(() => {
  return [
    { tz: 'US/Eastern', name: dateIsDST.value ? 'Eastern Daylight' : 'Eastern Standard' },
    { tz: 'US/Central', name: dateIsDST.value ? 'Central Daylight' : 'Central Standard' },
    { tz: 'US/Mountain', name: dateIsDST.value ? 'Mountain Daylight' : 'Mountain Standard' },
    { tz: 'US/Arizona', name: 'Mountain Standard' },
    { tz: 'US/Pacific', name: dateIsDST.value ? 'Pacific Daylight' : 'Pacific Standard' },
    { tz: 'US/Alaska', name: dateIsDST.value ? 'Alaska Daylight' : 'Alaska Standard' },
    { tz: 'UTC', name: 'UTC' },
  ];
});

// TODO: Maybe there's a built-in Date function to get this formatting?
const thumbLabel = computed(() => {
  const offset = getTimezoneOffset(selectedTimezone.value, date.value);
  const dateObj = new Date(timestamp.value + offset);
  const hours = dateObj.getUTCHours();
  const amPm = hours >= 12 ? "PM" : "AM";
  let hourValue = hours % 12;
  if (hourValue === 0) {
    hourValue = 12;
  }
  return `${date.value.getUTCMonth() + 1}/${dateObj.getUTCDate()}/${dateObj.getUTCFullYear()} ${hourValue}:${dateObj.getUTCMinutes().toString().padStart(2, '0')} ${amPm}`;
});




function updateHash() {
  if (window.location.hash.includes("extreme-events")) {
    activateExtremeEvents();
  }
}


function updateURL() {
  if (map.value) {
    const center = map.value.getCenter();
    let stateObj = null as Record<string, string> | null;
    if (showExtendedRangeFeatures) {
      stateObj = {
        lat: `${center.lat.toFixed(4)}`,
        lon: `${center.lng.toFixed(4)}`,
        zoom: `${map.value.getZoom()}`,
        t: `${timestamp.value}`,
        extendedRange: `${showExtendedRange.value}`
      };
    } else {
      stateObj = {
        lat: `${center.lat.toFixed(4)}`,
        lon: `${center.lng.toFixed(4)}`,
        zoom: `${map.value.getZoom()}`,
        t: `${timestamp.value}`
      };
    }
    const url = new URL(location.origin);
    const searchParams = new URLSearchParams(stateObj ?? {});
    // const hash = window.location.hash;
    // url.hash = hash;
    url.pathname = location.pathname;
    window.history.replaceState(null, '', url.toString());
    url.search = searchParams.toString();
    currentUrl.value = url.toString();
    // window.history.replaceState(stateObj, '', url);
  }
}

function cmapNO2(x: number): string {
  const rgb = cbarNO2(0, 1, x);
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]},1)`;
}

async function geocodingInfoForSearchLimited(searchText: string): Promise<MapBoxFeatureCollection | null> {
  return geocodingInfoForSearch(searchText, {
    countries: ["US", "CA", "MX", "CU", "BM", "HT", "DO"],
    limit: 10,
  }).catch(_err => null);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function resetMapBounds() {
  setView([40.044, -98.789] as LatLngPair, 4);
}

function setLocationFromSearch(items: [MapBoxFeature | null, string]) {
  const [feature, text] = items;
  if (feature !== null) {
    // Latitude, Longitude order
    const coordinates: LatLngPair = [feature.center[1], feature.center[0]] as LatLngPair;
    setView(coordinates, 12);
    setMarker(coordinates);
    userSelectedLocations.push(text);
  }
}

function play() {
  playInterval.value = setInterval(() => {
    if (timeIndex.value >= maxIndex.value) {
      if (playInterval.value) {
        // clearInterval(this.playInterval);
        // this.playInterval = null;
        // let it loop
        timeIndex.value = minIndex.value;
      }
    } else {
      timeIndex.value += 1;
    }
  }, 1000);
}


function pause() {
  if (playInterval.value) {
    clearInterval(playInterval.value);
  }
}

const showSinglePointWarning = ref(false);
function handlePlayWithoutData() {
  console.log('No data available for the selected time. Please select a different time.');
  playing.value = false;
  pause();
  showSinglePointWarning.value = true;
}

function getCloudFilename(date: Date): string {
  const filename = getTempoFilename(date);
  if (useHighRes.value) {
    return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/clouds/images/' + filename;
  } else {
    return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/clouds/images/resized_images/' + filename;
  }
}


function getTempoFilename(date: Date): string {
  return `tempo_${date.getUTCFullYear()}-${zpad(date.getUTCMonth() + 1)}-${zpad(date.getUTCDate())}T${zpad(date.getUTCHours())}h${zpad(date.getUTCMinutes())}m.png`;
}


function getTempoDataUrl(timestamp: number): string {
  if (showExtendedRange.value && extendedRangeTimestampsSet.value.has(timestamp)) {
    if (useHighRes.value) {
      return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/data_range_0_300/released/images/';
    }
    return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/data_range_0_300/released/images/resized_images/';
  }
  if (fosterTimestampsSet.value.has(timestamp)) {
    return 'https://tempo-images-bucket.s3.amazonaws.com/tempo-lite/';
  }

  if (erdTimestampsSet.value.has(timestamp)) {
    return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/early_release/images/';
  }

  if (newTimestampsSet.value.has(timestamp)) {
    if (useHighRes.value) {
      return 'https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/released/images/';
    }
    return "https://raw.githubusercontent.com/johnarban/tempo-data-holdings/main/released/images/resized_images/";
  }

  return '';
}




function imagePreload() {
  if (!preload.value) {
    return;
  }
  // console.log('preloading images for ', this.thumbLabel);
  const times = timestamps.value.slice(minIndex.value, maxIndex.value + 1);
  const images = times.map(ts => getTempoDataUrl(ts) + getTempoFilename(new Date(ts)));
  const cloudImages = times.reduce((acc: string[], ts) => {
    if (cloudTimestampsSet.value.has(ts)) {
      acc.push(getCloudFilename(new Date(ts)));
    }
    return acc;
  }, []);
  images.push(...cloudImages);
  const promises = _preloadImages(images);
  let loaded = 0;
  loadedImagesProgress.value = 0;
  promises.forEach((promise) => {
    promise.then(() => {
      loaded += 1;
      loadedImagesProgress.value = (loaded / promises.length) * 100;
    }).catch((err) => {
      console.error('error loading image', err);
    });
  });
}

function within1Day(date1: Date, date2: Date): boolean {
  const diff = Math.abs(date1.getTime() - date2.getTime());
  return diff <= (24 * 60 * 60 * 1000);
}

function goToLocationOfInterst(index: number, subindex: number) {
  if (index < 0 || index >= locationsOfInterest.value.length) {
    console.warn('Invalid index for location of interest');
    return;
  }
  const loi = locationsOfInterest.value[index][subindex];
  const loiDay = new Date(loi.time);
  console.log(`Single date selected: ${singleDateSelected.value}, LOI day: ${loiDay}`);
  
  if (!within1Day(singleDateSelected.value, loiDay)) {
    singleDateSelected.value = uniqueDays.value[uniqueDaysIndex(loiDay.getTime())];
  }
  // need to wait for singleDateSelected to update before setting timeIndex
  nextTick(() => {
    // set time index to loi index
    if (loi.index !== undefined) {
      console.log(`Setting time index to ${loi.index} for LOI at ${loi.day}`);
      timeIndex.value = loi.index;
    } else {
      console.warn('No index found for location of interest');
    }
    setView(loi.latlng, loi.zoom * zoomScale); // Adjust zoom level for maplibre
  });

}


function goToLA() {
  showLADialog.value = false;
  const event = interestingEvents.filter(e => e.label == 'LA Wildfires (Jan 8, 2025)');
  if (event !== undefined && map.value) {
    const loi = event[0].locations;
    setView(loi[0].latlng, loi[0].zoom * zoomScale); // Adjust zoom level for maplibre
  }
}


function activateLAViewer() {
  showLADialog.value = true;
}


function activateExtremeEvents() {
  // Find the LA Wildfires event
  const laWildfireIndex = interestingEvents.findIndex(
    event => event.label?.includes("LA Wildfires")
  );

  if (laWildfireIndex !== -1) {
    // Set the radio to select this event
    radio.value = laWildfireIndex;
    // Make sure extended range is on
    showExtendedRange.value = true;
  }
}

function onTimeSliderEnd(_value: number) {
  timeSliderUsedCount += 1; 
}

function onOpacitySliderEnd(_value: number) {
  opacitySliderUsedCount += 1;
}

async function createUserEntry() {
  if (responseOptOut.value) {
    return;
  }

  const response = await fetch(`${STORY_DATA_URL}/${uuid}`, {
    method: "GET",
    // eslint-disable-next-line @typescript-eslint/naming-convention
    headers: { "Authorization": process.env.VUE_APP_CDS_API_KEY ?? "" }
  });
  const content = await response.json();
  const userExists = response.status === 200 && content.response?.user_uuid != undefined;
  
  if (!userExists) {
    fetch(`${STORY_DATA_URL}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Authorization": process.env.VUE_APP_CDS_API_KEY ?? "",
      },
      body: JSON.stringify({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        user_uuid: uuid,
      }),
    });
  }
  
  if (ratingOptOut.value) {
    return;
  }
  
  // let gaveRating = false;
  // if (userExists) {
  //   try {
  //     const ratingResponse = await fetch(`${STORY_RATING_URL}/${uuid}`, {
  //       method: "GET",
  //       // eslint-disable-next-line @typescript-eslint/naming-convention
  //       headers: { "Authorization": process.env.VUE_APP_CDS_API_KEY ?? "" }
  //     });

  //     const ratingContent = await ratingResponse.json();
  //     gaveRating = ratingResponse.status === 200 && ratingContent.ratings?.length > 0;
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }
  //
  // if (!gaveRating) {
  //   ratingTimeout = setTimeout(() => {
  //     showRating.value = true; 
  //   }, 60_000);
  // }
  
  
}

function resetData() {
  whatsNewOpenedCount = 0;
  introductionOpenedCount = 0;
  userGuideOpenedCount = 0;
  aboutDataOpenedCount = 0;
  creditsOpenedCount = 0;
  shareButtonClickedCount = 0;
  playButtonClickedCount = 0;
  timeSliderUsedCount = 0;
  opacitySliderUsedCount = 0;
  userSelectedCalendarDates = [];
  userSelectedTimezones = [];
  userSelectedLocations = [];
  userSelectedNotableEvents = [];

  aboutDataOpenTimeMs = 0;
  userGuideOpenTimeMs = 0;
  introductionOpenTimeMs = 0;
  whatsNewOpenTimeMs = 0;
  creditsOpenTimeMs = 0;
  fieldOfRegardToggled = false;
  cloudMaskToggled = false;
  hiResDataToggled = false;

  const now = Date.now();
  creditsTimestamp = showCredits.value ? now : null;
  aboutDataTimestamp = showAboutData.value ? now : null;
}

async function updateUserData() {
  if (responseOptOut.value) {
    return;
  }

  const now = Date.now();
  const creditsTime = (showCredits.value && creditsTimestamp !== null) ? now - creditsTimestamp : creditsOpenTimeMs;
  const aboutDataTime = (showAboutData.value && aboutDataTimestamp !== null) ? now - aboutDataTimestamp: aboutDataOpenTimeMs;
  const whatsNewTime = (showChanges.value && whatsNewTimestamp !== null) ? now  - whatsNewTimestamp : whatsNewOpenTimeMs;
  const introductionTime = (introductionOpen.value && introductionTimestamp !== null) ? now - introductionTimestamp : introductionOpenTimeMs;
  const userGuideTime = (userGuideOpen.value && userGuideTimestamp !== null) ? now - userGuideTimestamp : userGuideOpenTimeMs;

  fetch(`${STORY_DATA_URL}/${uuid}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Authorization": process.env.VUE_APP_CDS_API_KEY ?? "",
    },
    body: JSON.stringify({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_whats_new_opened_count: whatsNewOpenedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_whats_new_open_time_ms: whatsNewTime,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_introduction_opened_count: introductionOpenedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_introduction_open_time_ms: introductionTime,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_user_guide_opened_count: userGuideOpenedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_user_guide_open_time_ms: userGuideTime,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_about_data_opened_count: aboutDataOpenedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_about_data_open_time_ms: aboutDataTime,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_credits_opened_count: creditsOpenedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_credits_open_time_ms: creditsTime,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_share_button_clicked_count: shareButtonClickedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_selected_calendar_dates: userSelectedCalendarDates,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_selected_timezones: userSelectedTimezones,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_selected_locations: userSelectedLocations,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_selected_notable_events: userSelectedNotableEvents,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_play_clicked_count: playButtonClickedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_time_slider_used_count: timeSliderUsedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delta_opacity_slider_used_count: opacitySliderUsedCount,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      field_of_regard_toggled: fieldOfRegardToggled,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      cloud_mask_toggled: cloudMaskToggled,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      high_res_data_toggled: hiResDataToggled,
    }),
    keepalive: true,
  }).then(() => {
    resetData();
  });
}

watch(timestampsLoaded, (loaded: boolean) => {
  if (loaded) {
    console.log('timestamps loaded');
    if (initState.value.t) {
      let index = uniqueDaysIndex(initState.value.t);
      if (index == -1) {
        return;
      }
      console.log('set the date');
      singleDateSelected.value = uniqueDays.value[index];
      index = nearestDateIndex(new Date(initState.value.t));
      if (index == -1) {
        return;
      }
      timeIndex.value = index;
      // FIXME if needed. if we find the time is not being set, use nextTick
      // this.$nextTick(() => { this.timeIndex = index;});
    }
  }
});

watch(timestamp, (_val: number) => {
  updateURL();
});

watch(introSlide, (val: number) => {
  inIntro.value = val < 5;
});

watch(dontShowIntro, (val: boolean) => {
  window.localStorage.setItem("dontShowIntro", val.toString());
  if (!val) {
    inIntro.value = true;
  }
});

watch(inIntro, (value: boolean) => {
  if (!value) {
    if (responseOptOut.value === null && !hasOptOutBeenOpened) {
      showPrivacyDialog.value = true;
    }
  }
});

watch(showPrivacyDialog, (show: boolean) => {
  if (show) {
    hasOptOutBeenOpened = true;
  }
});

watch(responseOptOut, (optOut: boolean | null) => {
  if (optOut !== null) {
    window.localStorage.setItem(OPT_OUT_KEY, String(optOut));
    if (optOut) {
      clearRatingTimeout();
      showRating.value = false;
    }
  }
});

watch(ratingOptOut, (optOut: boolean | null) => {
  if (optOut !== null) {
    window.localStorage.setItem(RATING_OPT_OUT_KEY, String(optOut));
    if (optOut) {
      clearRatingTimeout();
    }
  }
});

watch(loadedImagesProgress, (val: number) => {
  playing.value = false;
  const btn = document.querySelector('#play-pause-button');
  if (btn) {
    if (val < 100) {
      btn.setAttribute('disabled', 'true');
    } else {
      btn.removeAttribute('disabled');
    }
  }
});

watch(playing, (val: boolean) => {
  if (val) {
    play();
    playButtonClickedCount += 1;
  } else {
    pause();
  }
});

watch(imageUrl, (_url: string) => {
  updateFieldOfRegard();
});

// watch(cloudUrl, (_url: string) => {
//   // nothing to do here.
// });

watch(useHighRes, () => {
  hiResDataToggled = true;
  imagePreload();
});



watch(showFieldOfRegard, (_show: boolean) => {
  fieldOfRegardToggled = true;
});

watch(showClouds, (_show: boolean) => {
  cloudMaskToggled = true;
});

watch(showLocationMarker, (show: boolean) => {
  if (locationMarker.value) {
    if (show && map.value) {
      locationMarker.value.addTo(map.value);
      return;
    } else {
      locationMarker.value.remove();
      return;
    }
  }
});

watch(timestamps, () => {
  singleDateSelected.value = uniqueDays.value[uniqueDays.value.length - 1];
});

watch(radio, (value: number | null) => {
  // reset the sublocation radio
  sublocationRadio.value = null;
  
  if (value == null) {
    setNearestDate(singleDateSelected.value.getTime());
    return;
  }
  
  // is there a date for this event? then go to that date
  const date = datesOfInterest.value[value];
  if (date) {
    singleDateSelected.value = date;
  }
  // then go to the first location of interest for this event
  // nextTick(() => {
  //   sublocationRadio.value = 0;
  // });
});

watch(singleDateSelected, (value: Date) => {
  const timestamp = value.getTime();
  if (radio.value !== null) {
    const indices = datesOfInterest.value
      .map((d, i) => (d?.getTime() === timestamp ? i : -1))
      .filter(i => i !== -1);
    
    const sublocationIndices = locationsOfInterest.value[radio.value]
      .filter(loc => {
        const locTime = new Date(loc.time);
        return within1Day(locTime, value);
      });
    

    if (!indices.includes(radio.value) && sublocationIndices.length === 0) {
      const newRadioValue = indices.length > 0 ? indices[0] : null;
      if (newRadioValue !== radio.value) {
        radio.value = newRadioValue;
      }
    }
  }
  imagePreload();
});

watch(sublocationRadio, (value: number | null) => {
  if (value !== null && radio.value != null) {
    // nextTick so that singleDateSelected has time to update
    nextTick(() => goToLocationOfInterst(radio.value!, value));
  }
});


watch(showChanges, (_value: boolean) => {
  if (showNotice.value) {
    showNotice.value = false;
  }
});

watch(showExtendedRange, (_value: boolean) => {
  updateURL();
  imagePreload();
});

watch(showChanges, (show: boolean) => {
  const now = Date.now();
  if (show) {
    whatsNewTimestamp = now;
    whatsNewOpenedCount += 1;
  } else if (whatsNewTimestamp !== null) {
    whatsNewOpenTimeMs += (now - whatsNewTimestamp);
    whatsNewTimestamp = null;
  }
});

watch(showAboutData, (show: boolean) => {
  const now = Date.now();
  if (show) {
    aboutDataTimestamp = now;
    aboutDataOpenedCount += 1;
  } else if (aboutDataTimestamp !== null) {
    aboutDataOpenTimeMs += (now - aboutDataTimestamp);
    aboutDataTimestamp = null;
  }
});

watch(showCredits, (show: boolean) => {
  const now = Date.now();
  if (show) {
    creditsTimestamp = now;
    creditsOpenedCount += 1;
  } else if (creditsTimestamp !== null) {
    creditsOpenTimeMs += (now - creditsTimestamp);
    creditsTimestamp = null;
  }
});

watch(introductionOpen, (open: boolean) => {
  const now = Date.now();
  if (open) {
    introductionTimestamp = now;
    introductionOpenedCount += 1;
  } else if (introductionTimestamp !== null) {
    introductionOpenTimeMs += (now - introductionTimestamp);
    introductionTimestamp = null;
  }
});

watch(userGuideOpen, (open: boolean) => {
  const now = Date.now();
  if (open) {
    userGuideTimestamp = now;
    userGuideOpenedCount += 1;
  } else if (userGuideTimestamp !== null) {
    userGuideOpenTimeMs += (now - userGuideTimestamp);
    userGuideTimestamp = null;
  }
});

const radioSubloc: ComputedRef<[number | null, number | null]> = computed(() => [radio.value, sublocationRadio.value]); 
watch(radioSubloc, (item: [number | null, number | null]) => {
  const radio = item[0];
  const subRadio = item[1];
  if (radio === null || subRadio === null) {
    return [];
  }
  const eventText = interestingEvents[radio].label ?? "";
  const subEventText = locationsOfInterest.value[radio][subRadio].text;
  userSelectedNotableEvents.push([eventText, subEventText]);
});

watch(selectedTimezone, (timezone: string) => {
  userSelectedTimezones.push(timezone);
});

watch(singleDateSelected, (date: Date) => {
  if (!timestampsLoaded.value ) return;
  userSelectedCalendarDates.push(date.getTime());
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_marquee_alert = _resolveComponent("marquee-alert")!
  const _component_cds_dialog = _resolveComponent("cds-dialog")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_share_button = _resolveComponent("share-button")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_colorbar_horizontal = _resolveComponent("colorbar-horizontal")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_info_button = _resolveComponent("info-button")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_location_search = _resolveComponent("location-search")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_colorbar = _resolveComponent("colorbar")!
  const _component_icon_button = _resolveComponent("icon-button")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_funding_acknowledgement = _resolveComponent("funding-acknowledgement")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_user_experience = _resolveComponent("user-experience")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_cds_privacy_policy = _resolveComponent("cds-privacy-policy")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(cssVars.value)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_overlay, {
        "model-value": inIntro.value,
        style: _normalizeStyle(cssVars.value),
        id: "intro-background"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_dialog, {
            modelValue: inIntro.value,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inIntro).value = $event))
          }, {
            default: _withCtx(() => [
              (inIntro.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_v_window, {
                      modelValue: introSlide.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((introSlide).value = $event))
                    }, {
                      additional: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_font_awesome_icon, {
                            size: "xl",
                            class: "ma-3",
                            color: "#b3d5e6",
                            icon: "square-xmark",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (inIntro.value = !inIntro.value)),
                            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (inIntro.value = !inIntro.value), ["enter"])),
                            tabindex: "0",
                            "tooltip-location": "start"
                          })
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, {
                          value: 1,
                          id: "splash-screen"
                        }, {
                          default: _withCtx(() => [
                            _cache[83] || (_cache[83] = _createElementVNode("div", { id: "first-splash-row" }, [
                              _createElementVNode("div", { id: "splash-screen-text" }, " What Is in the Air You Breathe? "),
                              _createElementVNode("div", null, " Explore daily pollution maps over North America and find out. ")
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_v_btn, {
                                class: "splash-get-started",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (introSlide.value++)),
                                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (introSlide.value++), ["enter"])),
                                color: accentColor.value,
                                density: _unref(display).smAndDown ? 'compact' : 'default',
                                size: "x-large",
                                variant: "elevated",
                                rounded: "lg"
                              }, {
                                default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                  _createTextVNode(" Get Started ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["color", "density"])
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                              _cache[80] || (_cache[80] = _createTextVNode(" Brought to you by ", -1)),
                              _cache[81] || (_cache[81] = _createElementVNode("a", {
                                href: "https://www.cosmicds.cfa.harvard.edu/",
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }, "Cosmic Data Stories", -1)),
                              _cache[82] || (_cache[82] = _createTextVNode(". ", -1)),
                              _createElementVNode("div", _hoisted_4, [
                                _cache[79] || (_cache[79] = _createElementVNode("a", {
                                  href: "https://www.si.edu/",
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, [
                                  _createElementVNode("img", {
                                    alt: "Smithsonian Logo",
                                    src: "220px-Smithsonian_sun_logo_no_text.svg.png"
                                  })
                                ], -1)),
                                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'sciact', 'nasa'] })
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 2 }, {
                          default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                            _createElementVNode("div", { class: "intro-text" }, [
                              _createElementVNode("p", { class: "mb-5" }, " The TEMPO satellite mission (Tropospheric Emissions: Monitoring Pollution), launched in April 2023, is the first space-based instrument to measure major air pollutants across the North American continent every daylight hour at high spatial resolution. A collaboration between NASA and the Smithsonian Astrophysical Observatory, the TEMPO instrument gathers hourly daytime scans of the atmosphere over North America from the Atlantic Ocean to the Pacific Coast and from the Yucatán Peninsula to central Canada. ")
                            ], -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 3 }, {
                          default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                            _createElementVNode("div", { class: "intro-text mb-3" }, [
                              _createElementVNode("p", { class: "mb-3" }, [
                                _createTextVNode(" This Data Story provides an introduction to what can be learned from TEMPO’s data, which became publicly available May 20, 2024. The map here visualizes hourly Nitrogen Dioxide (NO"),
                                _createElementVNode("sub", null, "2"),
                                _createTextVNode(") data over time. NO"),
                                _createElementVNode("sub", null, "2"),
                                _createTextVNode(" can be produced by: ")
                              ]),
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, "Burning of fossil fuels—for example from vehicles, power plants, manufacturing sites, and oil refineries"),
                                _createElementVNode("li", null, "Fires and biomass burning—including wildfires and prescribed burns, as well as burning of vegetation for land clearing"),
                                _createElementVNode("li", null, [
                                  _createTextVNode("Bacteria, which naturally convert nitrogen in soil into compounds that can form NO"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(". Agricultural use of nitrogen-based fertilizers increases the amount of NO"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(" produced by these bacteria.")
                                ]),
                                _createElementVNode("li", null, [
                                  _createTextVNode("Lightning, which triggers a chemical reaction that turns harmless N"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(" in the atmosphere into NO"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(". ")
                                ])
                              ]),
                              _createElementVNode("p", { class: "mt-3" }, " For each date, you can see the scans beginning on the East Coast in the morning, and ending on the West Coast as the Sun sets. ")
                            ], -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: 4 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _cache[96] || (_cache[96] = _createElementVNode("p", { class: "mb-3" }, " In this interactive page you can: ", -1)),
                              _createElementVNode("ul", null, [
                                _cache[92] || (_cache[92] = _createElementVNode("li", null, " Use the search box to navigate a location of your choice. ", -1)),
                                _cache[93] || (_cache[93] = _createElementVNode("li", null, [
                                  _createTextVNode(" Select a date and press the “Play” button or scroll the time slider to view the changing concentrations of NO"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(" on those dates. ")
                                ], -1)),
                                _createElementVNode("li", null, [
                                  _cache[87] || (_cache[87] = _createTextVNode(" Click ", -1)),
                                  _createVNode(_component_v_icon, { style: {"color":"#ffcc33"} }, {
                                    default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                      _createTextVNode("mdi-share-variant", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[88] || (_cache[88] = _createTextVNode(" to share your selected location, date, and time with others. ", -1))
                                ]),
                                _createElementVNode("li", {
                                  style: _normalizeStyle(cssVars.value)
                                }, [
                                  _cache[90] || (_cache[90] = _createTextVNode(" Press the ", -1)),
                                  _createVNode(_component_v_icon, {
                                    style: {"font-size":"1.3em","color":"var(--accent-color)"},
                                    elevation: "1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                                      _createTextVNode("mdi-information-variant-circle-outline", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[91] || (_cache[91] = _createTextVNode(" button next to each Featured Topic to get an overview of what you can explore in the TEMPO data. ", -1))
                                ], 4),
                                _cache[94] || (_cache[94] = _createElementVNode("li", null, " For each Featured Topic, select Example Cases to investigate specific pollution events. ", -1)),
                                _cache[95] || (_cache[95] = _createElementVNode("li", null, " You can use the “Timezone” setting to investigate how pollution evolves over the day in different parts of the country, for example as rush hour progresses in large cities. ", -1))
                              ]),
                              _createVNode(_component_v_checkbox, {
                                modelValue: dontShowIntro.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dontShowIntro).value = $event)),
                                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (dontShowIntro.value = !dontShowIntro.value), ["enter"])),
                                label: "Don't show this introduction at launch",
                                color: "#c10124",
                                "hide-details": ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        ((introSlide.value > 1))
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              id: "intro-next-button",
                              color: accentColor.value,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (introSlide.value--)),
                              onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (introSlide.value--), ["enter"])),
                              elevation: "0"
                            }, {
                              default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                                _createTextVNode(" Back ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["color"]))
                          : _createCommentVNode("", true)
                      ]),
                      ((introSlide.value > 1))
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            id: "intro-next-button",
                            color: accentColor.value,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (introSlide.value++)),
                            onKeyup: _cache[10] || (_cache[10] = _withKeys(($event: any) => (introSlide.value++), ["enter"])),
                            elevation: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(introSlide.value < 4 ? 'Next' : 'Get Started'), 1)
                            ]),
                            _: 1
                          }, 8, ["color"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["model-value", "style"]),
      _createElementVNode("div", _hoisted_7, [
        (smallSize.value && showExtendedRangeFeatures && extendedRangeAvailable.value)
          ? (_openBlock(), _createBlock(_component_marquee_alert, {
              key: 0,
              timeout: 30000,
              message: "You can view data with an extend range for the \n            duration of the LA fires. See the 🔥 button on the map"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_marquee_alert, {
          modelValue: dataLagWarning.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dataLagWarning).value = $event)),
          style: {"font-size":"0.9em","gap":"1em"},
          icon: "mdi-calendar-alert",
          type: "error",
          timeout: 10000,
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(new Date(timestamps.value[timestamps.value.length-1]).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })) + " is the latest date with available data. See ", 1),
            _cache[98] || (_cache[98] = _createElementVNode("a", {
              href: "https://asdc.larc.nasa.gov/project/TEMPO/",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "NASA's EarthData website", -1)),
            _cache[99] || (_cache[99] = _createTextVNode(" and ", -1)),
            _cache[100] || (_cache[100] = _createElementVNode("a", {
              href: "https://github.com/Smithsonian/TEMPO-Observations-log/blob/main/daily_log.md",
              target: "_blank",
              rel: "noopener noreferrer"
            }, "TEMPO Observing Log", -1)),
            _cache[101] || (_cache[101] = _createTextVNode(" for more information. ", -1))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[113] || (_cache[113] = _createElementVNode("a", {
              href: "https://tempo.si.edu",
              target: "_blank",
              rel: "noopener noreferrer"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "TEMPO Logo"
              })
            ], -1)),
            _cache[114] || (_cache[114] = _createElementVNode("h1", { id: "title" }, "What is in the Air You Breathe?", -1)),
            _createVNode(_component_cds_dialog, {
              title: "What's new",
              modelValue: showChanges.value,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showChanges).value = $event)),
              color: accentColor2.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(changes), (change) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "change-item mb-5",
                      key: change.date,
                      "data-date": change.date
                    }, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({"font-weight":"bold", "color": `${change.highlight ? "var(--smithsonian-yellow)" : "currentColor"}` })
                      }, _toDisplayString(change.date), 5),
                      _cache[102] || (_cache[102] = _createElementVNode("br", null, null, -1)),
                      _cache[103] || (_cache[103] = _createTextVNode()),
                      _createElementVNode("span", {
                        innerHTML: change.html
                      }, null, 8, _hoisted_12),
                      _createTextVNode(_toDisplayString(change.text), 1)
                    ], 8, _hoisted_11))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "color"]),
            _createElementVNode("div", _hoisted_13, [
              ((new Date('2026-07-25 00:00:00') > new Date()))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "whats-new-button pulse",
                    "aria-label": "What's new",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (showChanges.value = true)),
                    onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (showChanges.value = true), ["enter"])),
                    variant: "outlined",
                    rounded: "lg",
                    color: accentColor2.value,
                    elevation: "0",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_tooltip, {
                        location: "bottom",
                        activator: "parent",
                        disabled: mobile.value,
                        text: "What's new"
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                          _createTextVNode("mdi-creation", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["color"]))
                : _createCommentVNode("", true),
              _createVNode(_component_share_button, {
                source: currentUrl.value,
                buttonColor: "black",
                iconColor: accentColor2.value,
                elevation: "0",
                size: "small",
                rounded: "1",
                "tooltip-disabled": mobile.value,
                onShare: _cache[16] || (_cache[16] = ($event: any) => (_isRef(shareButtonClickedCount) //@ts-ignore
 ? shareButtonClickedCount.value += 1 : shareButtonClickedCount += 1)),
                alert: ""
              }, null, 8, ["source", "iconColor", "tooltip-disabled"]),
              _createVNode(_component_v_btn, {
                "aria-role": "menu",
                "aria-label": "Show menu",
                size: "small",
                class: "menu-button",
                variant: "outlined",
                rounded: "lg",
                color: accentColor2.value,
                elevation: "5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "x-large" }, {
                    default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                      _createTextVNode("mdi-menu", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_menu, { activator: "parent" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            tabindex: "0",
                            "aria-label": "See recent changes",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (showChanges.value = true)),
                            onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (showChanges.value = true), ["enter"]))
                          }, {
                            default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                              _createTextVNode(" What's New ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            tabindex: "0",
                            "aria-label": "Show introduction",
                            onClick: _cache[19] || (_cache[19] = () => {introSlide.value = 1; inIntro.value = true;}),
                            onKeyup: _cache[20] || (_cache[20] = _withKeys(() => {introSlide.value = 1; inIntro.value = true;}, ["enter"]))
                          }, {
                            default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                              _createTextVNode(" Introduction ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            tabindex: "0",
                            "aria-label": "Show user guide",
                            onClick: _cache[21] || (_cache[21] = () => {introSlide.value = 4; inIntro.value = true;}),
                            onKeyup: _cache[22] || (_cache[22] = _withKeys(() => {introSlide.value = 4; inIntro.value = true;}, ["enter"]))
                          }, {
                            default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                              _createTextVNode(" User Guide ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            tabindex: "0",
                            "aria-label": "Show dialog telling about the data",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (showAboutData.value = true)),
                            onKeyup: _cache[24] || (_cache[24] = _withKeys(($event: any) => (showAboutData.value = true), ["enter"]))
                          }, {
                            default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                              _createTextVNode(" About the Data ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, { "aria-label": "Leave Page to Educator Resources" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_14, [
                                _cache[111] || (_cache[111] = _createTextVNode("Educator Resources", -1)),
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                    _createTextVNode("mdi-open-in-new", -1)
                                  ]))]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_list_item, {
                            tabindex: "0",
                            "aria-label": "Show credits",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (showCredits.value = true)),
                            onKeyup: _cache[26] || (_cache[26] = _withKeys(($event: any) => (showCredits.value = true), ["enter"]))
                          }, {
                            default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                              _createTextVNode(" Credits ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["color"])
            ])
          ]),
          _cache[172] || (_cache[172] = _createElementVNode("div", {
            id: "where",
            class: "big-label"
          }, "where", -1)),
          _createElementVNode("div", _hoisted_15, [
            (_unref(display).width.value <= 750)
              ? (_openBlock(), _createBlock(_component_colorbar_horizontal, {
                  key: 0,
                  label: "Amount of NO2",
                  backgroundColor: "transparent",
                  nsteps: 255,
                  cmap: cmapNO2,
                  "start-value": "1",
                  "end-value": showingExtendedRange.value ? '300' : '150',
                  extend: true
                }, {
                  label: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                    _createElementVNode("div", { style: {"text-align":"center"} }, [
                      _createTextVNode("Amount of NO₂ "),
                      _createElementVNode("span", { class: "unit-label" }, "(10¹⁴ mol/cm²)")
                    ], -1)
                  ]))]),
                  _: 1
                }, 8, ["end-value"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_overlay, {
                  modelValue: loadedImagesProgress.value < 100,
                  style: {"z-index":"1000"},
                  class: "align-center justify-center",
                  contained: "",
                  opacity: ".8"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[116] || (_cache[116] = _createElementVNode("label", {
                        class: "text-black",
                        for: "loading-circle-progress"
                      }, "Loading Data...", -1)),
                      _createVNode(_component_v_progress_circular, {
                        id: "loading-circle-progress",
                        style: {"z-index":"1000"},
                        size: 100,
                        width: 15,
                        "model-value": loadedImagesProgress.value,
                        color: "#092088"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(loadedImagesProgress.value.toFixed(0)) + "% ", 1)
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_unref(showFieldOfRegard) && !smallSize.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[117] || (_cache[117] = [
                    _createElementVNode("hr", { class: "line-legend" }, null, -1),
                    _createTextVNode("TEMPO Field of Regard", -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_menu, {
                id: "map-controls",
                modelValue: showControls.value,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((showControls).value = $event)),
                "close-on-content-click": false
              }, {
                activator: _withCtx(({ props }) => [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      class: ['mx-2', smallSize.value ? 'mt-0' : 'mt-5'],
                      elevation: "2",
                      color: "white",
                      icon: "",
                      style: {"outline":"2px solid #b6b6b6"},
                      rounded: "0",
                      size: "x-small"
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          color: "black",
                          size: "x-large"
                        }, {
                          default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
                            _createTextVNode("mdi-tune-variant", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["class"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "controls-card" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        style: {"position":"absolute","right":"16px","cursor":"pointer"},
                        icon: "square-xmark",
                        size: "xl",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (showControls.value = false)),
                        onKeyup: _cache[28] || (_cache[28] = _withKeys(($event: any) => (showControls.value = false), ["enter"])),
                        color: accentColor2.value,
                        tabindex: "0"
                      }, null, 8, ["color"]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[119] || (_cache[119] = _createElementVNode("div", { id: "opacity-slider-label" }, "TEMPO data opacity", -1)),
                        _createVNode(_component_v_slider, {
                          modelValue: opacity.value,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((opacity).value = $event)),
                          min: 0,
                          max: 1,
                          color: "#c10124",
                          density: "compact",
                          "hide-details": "",
                          class: "mb-4",
                          onEnd: onOpacitySliderEnd
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_v_checkbox, {
                          modelValue: showRoads.value,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((showRoads).value = $event)),
                          onKeyup: _cache[31] || (_cache[31] = _withKeys(($event: any) => (showRoads.value = !showRoads.value), ["enter"])),
                          label: "Show Roads",
                          color: "#c10124",
                          "hide-details": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_v_checkbox, {
                          modelValue: _unref(showFieldOfRegard),
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_isRef(showFieldOfRegard) ? (showFieldOfRegard).value = $event : null)),
                          onKeyup: _cache[33] || (_cache[33] = _withKeys(($event: any) => (showFieldOfRegard.value = !_unref(showFieldOfRegard)), ["enter"])),
                          label: "TEMPO Field of Regard",
                          color: "#c10124",
                          "hide-details": ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_info_button, null, {
                          default: _withCtx(() => [
                            _cache[124] || (_cache[124] = _createElementVNode("p", null, " The TEMPO satellite observes the atmosphere over North America, from the Atlantic Ocean to the Pacific Coast, and from roughly Mexico City to central Canada. ", -1)),
                            _createElementVNode("p", null, [
                              _cache[120] || (_cache[120] = _createTextVNode(" The TEMPO Field of Regard (in ", -1)),
                              _cache[121] || (_cache[121] = _createElementVNode("span", { class: "text-red" }, "red", -1)),
                              _cache[122] || (_cache[122] = _createTextVNode(", currently ", -1)),
                              _createElementVNode("em", null, _toDisplayString(_unref(showFieldOfRegard) ? 'visible' : "hidden"), 1),
                              _cache[123] || (_cache[123] = _createTextVNode(") is the area over which the satellite takes measurements. ", -1))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_v_checkbox, {
                          modelValue: showClouds.value,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((showClouds).value = $event)),
                          onKeyup: _cache[35] || (_cache[35] = _withKeys(($event: any) => (showClouds.value = !showClouds.value), ["enter"])),
                          disabled: !cloudDataAvailable.value,
                          label: cloudDataAvailable.value ? 'Show Cloud Mask' : 'No Cloud Data Available',
                          color: "#c10124",
                          "hide-details": ""
                        }, null, 8, ["modelValue", "disabled", "label"]),
                        _createVNode(_component_info_button, null, {
                          default: _withCtx(() => [...(_cache[125] || (_cache[125] = [
                            _createElementVNode("p", null, [
                              _createTextVNode(" The cloud mask shows where the satellite could not measure NO"),
                              _createElementVNode("sub", null, "2"),
                              _createTextVNode(" because of cloud cover. ")
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_v_checkbox, {
                          disabled: !highresAvailable.value,
                          modelValue: useHighRes.value,
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((useHighRes).value = $event)),
                          onKeyup: _cache[37] || (_cache[37] = _withKeys(($event: any) => (useHighRes.value = !useHighRes.value), ["enter"])),
                          label: "Use High Resolution Data",
                          color: "#c10124",
                          "hide-details": ""
                        }, null, 8, ["disabled", "modelValue"]),
                        _createVNode(_component_info_button, null, {
                          default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                            _createElementVNode("p", null, " By default we show data at 1/2 resolution for performance. ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      (showExtendedRangeFeatures && extendedRangeAvailable.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_v_checkbox, {
                              disabled: !extendedRangeAvailable.value,
                              modelValue: showExtendedRange.value,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((showExtendedRange).value = $event)),
                              onKeyup: _cache[39] || (_cache[39] = _withKeys(($event: any) => (showExtendedRange.value = !showExtendedRange.value), ["enter"])),
                              label: "Use Extended NO2 range",
                              color: "#c10124",
                              "hide-details": ""
                            }, null, 8, ["disabled", "modelValue"]),
                            _createVNode(_component_info_button, null, {
                              default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                                _createElementVNode("p", null, [
                                  _createTextVNode(" If data is available, show map with extended range of NO"),
                                  _createElementVNode("sub", null, "2"),
                                  _createTextVNode(" values. ")
                                ], -1)
                              ]))]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_location_search, {
                  modelValue: searchOpen.value,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((searchOpen).value = $event)),
                  small: "",
                  "stay-open": "",
                  buttonSize: "sm",
                  "persist-selected": "",
                  "search-provider": geocodingInfoForSearchLimited,
                  onSetLocation: setLocationFromSearch,
                  onError: _cache[42] || (_cache[42] = (error) => searchErrorMessage.value = error)
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                (!smallSize.value && extendedRangeAvailable.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: activateLAViewer,
                      onKeyup: _withKeys(activateLAViewer, ["enter"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(extendedRangeAvailable.value ? (showExtendedRange.value ? "Showing extended range" : "Use extreme events range") : "No extended range images available for this date"), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (smallSize.value && showExtendedRangeFeatures && extendedRangeAvailable.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      onClick: activateLAViewer,
                      onKeyup: _withKeys(activateLAViewer, ["enter"]),
                      icon: ""
                    }, {
                      default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                        _createTextVNode(" 🔥 ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_cds_dialog, {
                  title: "Extreme Events",
                  modelValue: showLADialog.value,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((showLADialog).value = $event)),
                  color: accentColor2.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _cache[129] || (_cache[129] = _createElementVNode("p", null, [
                              _createTextVNode(" Some events like the January 2025 Los Angeles fires generate so much smoke and pollution that NO"),
                              _createElementVNode("sub", null, "2"),
                              _createTextVNode(" levels can greatly exceed the default range used in the color scale for the TEMPO-lite viewer. To show more clearly where the very highest levels of NO"),
                              _createElementVNode("sub", null, "2"),
                              _createTextVNode(" are present, you can use an extended color stretch. ")
                            ], -1)),
                            _cache[130] || (_cache[130] = _createElementVNode("p", null, [
                              _createTextVNode(" By default we display values from 0.01-1.5×10"),
                              _createElementVNode("sup", null, "16"),
                              _createTextVNode(" molecules per square centimeter, check the box here to double the max of the range to 3×10"),
                              _createElementVNode("sup", null, "16"),
                              _createTextVNode(" molecules per square centimeter. The extended range will be available on dates with extreme events like the Los Angeles fire outbreaks. ")
                            ], -1)),
                            _createVNode(_component_v_checkbox, {
                              modelValue: showExtendedRange.value,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((showExtendedRange).value = $event)),
                              label: "Use extended data range"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "justify-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: accentColor2.value,
                          onClick: goToLA,
                          onKeyup: _withKeys(goToLA, ["enter"])
                        }, {
                          default: _withCtx(() => [...(_cache[131] || (_cache[131] = [
                            _createTextVNode(" Go To Los Angeles", -1)
                          ]))]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color"])
              ])
            ]),
            (_unref(display).width.value > 750)
              ? (_openBlock(), _createBlock(_component_colorbar, {
                  key: 1,
                  label: "Amount of NO2",
                  backgroundColor: "transparent",
                  nsteps: 255,
                  cmap: cmapNO2,
                  "start-value": "1",
                  "end-value": showingExtendedRange.value ? '300' : '150',
                  extend: true
                }, {
                  label: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                    _createElementVNode("div", { style: {"text-align":"center"} }, [
                      _createTextVNode("Amount of NO₂"),
                      _createElementVNode("br"),
                      _createElementVNode("span", { class: "unit-label" }, "(10¹⁴ molecules/cm²)")
                    ], -1)
                  ]))]),
                  _: 1
                }, 8, ["end-value"]))
              : _createCommentVNode("", true)
          ]),
          _cache[173] || (_cache[173] = _createElementVNode("div", {
            id: "when",
            class: "big-label"
          }, "when", -1)),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_v_slider, {
              class: _normalizeClass([
              "time-slider", 
              _unref(maxIndex) <= _unref(minIndex) ? "hide-first-last-ticks" : "",
              _unref(maxIndex) < _unref(minIndex) + 7 ? `hide-ticks-${_unref(minIndex) + 7 - _unref(maxIndex)}` : "",
              ]),
              disabled: _unref(maxIndex) <= _unref(minIndex),
              modelValue: timeSliderIndex.value,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((timeSliderIndex).value = $event)),
              min: _unref(minIndex),
              max: Math.max(_unref(minIndex) + 7,_unref(maxIndex)),
              step: 1,
              color: "#068ede95",
              "thumb-label": "always",
              "track-size": 10,
              "show-ticks": "always",
              "hide-details": "",
              onEnd: onTimeSliderEnd
            }, {
              "thumb-label": _withCtx(() => [
                _createElementVNode("div", _hoisted_30, _toDisplayString(thumbLabel.value), 1)
              ]),
              _: 1
            }, 8, ["class", "disabled", "modelValue", "min", "max"]),
            _createVNode(_component_icon_button, {
              id: "play-pause",
              "fa-icon": playing.value ? 'pause' : 'play',
              color: _unref(minIndex) >= _unref(maxIndex) ? '#AAAAAA' : 'var(--accent-color)',
              "focus-color": _unref(minIndex) >= _unref(maxIndex) ? '#AAAAAA' : 'var(--accent-color)',
              "tooltip-location": "bottom",
              "fa-size": "sm",
              onActivate: _cache[46] || (_cache[46] = () => {
              if (_unref(maxIndex) <= _unref(minIndex)) {
                handlePlayWithoutData();
                return;
              } 
              playing.value = !playing.value
              })
            }, null, 8, ["fa-icon", "color", "focus-color"]),
            _createVNode(_component_v_snackbar, {
              modelValue: showSinglePointWarning.value,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((showSinglePointWarning).value = $event)),
              timeout: 5000,
              color: "error",
              location: "bottom"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "black",
                  variant: "text",
                  onClick: _cache[47] || (_cache[47] = ($event: any) => (showSinglePointWarning.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[133] || (_cache[133] = [
                    _createElementVNode("span", { style: {"font-weight":"600"} }, "Close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _cache[134] || (_cache[134] = _createElementVNode("span", { style: {"font-weight":"600"} }, "Only one time is available for this date.", -1))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h2", null, [
                _cache[135] || (_cache[135] = _createTextVNode(" Select a Date ", -1)),
                (timestampsLoaded.value && (new Date(timestamps.value[timestamps.value.length-2]) < new Date(Date.now() - 2 * 24 * 60 * 60 * 1000)))
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      disabled: touchscreen.value,
                      text: "Data Availability Alert",
                      location: "right",
                      "open-on-focus": "",
                      "open-on-hover": ""
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          color: "error",
                          onClick: _cache[49] || (_cache[49] = () => dataLagWarning.value = !dataLagWarning.value),
                          onKeyup: _cache[50] || (_cache[50] = _withKeys(() => dataLagWarning.value = !dataLagWarning.value, ["enter"])),
                          icon: "mdi-calendar-alert",
                          variant: "tonal",
                          size: "default",
                          width: "35px",
                          height: "35px"
                        }), null, 16)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_v_radio_group, {
                  modelValue: radio.value,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((radio).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_date_picker, {
                      ref_key: "calendar",
                      ref: calendar,
                      "model-value": _unref(singleDateSelected),
                      onInternalModelChange: _cache[53] || (_cache[53] = (value) => {
                  if (value != null && value.getTime() != _unref(singleDateSelected).getTime()) {
                    radio.value = null;
                    singleDateSelected.value = value;
                    calendar.value?.closeMenu();
                  }
                }),
                      "allowed-dates": _unref(uniqueDays),
                      clearable: false,
                      "enable-time-picker": false,
                      "multi-dates": false,
                      transitions: false,
                      format: (date) => date?.toDateString(),
                      "preview-format": (date) => date?.toDateString(),
                      "no-today": "",
                      dark: ""
                    }, {
                      "action-buttons": _withCtx(() => [
                        _createElementVNode("button", {
                          class: "dp__action_button dp__action-latest",
                          onClick: _cache[51] || (_cache[51] = () => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1]),
                          onKeyup: _cache[52] || (_cache[52] = _withKeys(() => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1], ["enter"])),
                          disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                          elevation: "0",
                          size: "sm"
                        }, " Latest ", 40, _hoisted_34)
                      ]),
                      _: 1
                    }, 8, ["model-value", "allowed-dates", "format", "preview-format"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_v_tooltip, {
                  disabled: touchscreen.value,
                  text: "Previous Date"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      class: "rounded-icon-wrapper",
                      onClick: _unref(moveBackwardOneDay),
                      onKeyup: _withKeys(_unref(moveBackwardOneDay), ["enter"]),
                      disabled: _unref(singleDateSelected) === _unref(uniqueDays)[0],
                      color: "#009ade",
                      variant: "outlined",
                      elevation: "0",
                      size: "md"
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[136] || (_cache[136] = [
                            _createTextVNode("mdi-chevron-double-left", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["onClick", "onKeyup", "disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_tooltip, {
                  disabled: touchscreen.value,
                  text: "Get Data for latest available day"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      style: {"padding-inline":"4px"},
                      onClick: _cache[55] || (_cache[55] = () => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1]),
                      onKeyup: _cache[56] || (_cache[56] = _withKeys(() => singleDateSelected.value = _unref(uniqueDays)[_unref(uniqueDays).length - 1], ["enter"])),
                      disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                      color: "#009ade",
                      variant: "outlined",
                      elevation: "0",
                      size: "md"
                    }), {
                      default: _withCtx(() => [...(_cache[137] || (_cache[137] = [
                        _createTextVNode(" Latest Data ", -1)
                      ]))]),
                      _: 1
                    }, 16, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_tooltip, {
                  disabled: touchscreen.value,
                  text: "Next Date"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      class: "rounded-icon-wrapper",
                      onClick: _unref(moveForwardOneDay),
                      onKeyup: _withKeys(_unref(moveForwardOneDay), ["enter"]),
                      disabled: _unref(singleDateSelected) === _unref(uniqueDays)[_unref(uniqueDays).length - 1],
                      color: "#009ade",
                      variant: "outlined",
                      elevation: "0",
                      size: "md"
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[138] || (_cache[138] = [
                            _createTextVNode("mdi-chevron-double-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 16, ["onClick", "onKeyup", "disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              (loadedImagesProgress.value < 101)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    modelValue: loadedImagesProgress.value,
                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((loadedImagesProgress).value = $event)),
                    color: "#092088",
                    height: "20"
                  }, {
                    default: _withCtx(() => [
                      (loadedImagesProgress.value < 100)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Loading Data (" + _toDisplayString(loadedImagesProgress.value.toFixed(0)) + "%)", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_37, "Data Loaded"))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _cache[142] || (_cache[142] = _createElementVNode("hr", { style: {"border-color":"grey"} }, null, -1)),
            _createElementVNode("div", _hoisted_38, [
              _cache[139] || (_cache[139] = _createElementVNode("h2", null, "Featured Topics", -1)),
              _createVNode(_component_v_radio_group, {
                modelValue: radio.value,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((radio).value = $event)),
                row: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(interestingEvents), (event, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "d-flex flex-row align-center"
                    }, [
                      _createVNode(_component_v_radio, {
                        class: _normalizeClass(event.highlighted ? 'highlighted' : ''),
                        label: event.label,
                        value: index,
                        onKeyup: _withKeys(($event: any) => (radio.value = index), ["enter"])
                      }, null, 8, ["class", "label", "value", "onKeyup"]),
                      _createVNode(_component_info_button, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            style: {"display":"inline-block","margin":"0","padding":"0"},
                            innerHTML: event.info
                          }, null, 8, _hoisted_39)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (radio.value !== null )
              ? (_openBlock(), _createElementBlock("hr", _hoisted_40))
              : _createCommentVNode("", true),
            (radio.value !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _cache[140] || (_cache[140] = _createElementVNode("h3", { class: "mb-1" }, "Example Cases", -1)),
                  (radio.value !== null)
                    ? (_openBlock(), _createBlock(_component_v_radio_group, {
                        key: 0,
                        modelValue: sublocationRadio.value,
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((sublocationRadio).value = $event)),
                        row: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsOfInterest.value[radio.value], (loi, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "sublocation-radio-wrapper d-flex flex-row align-center space-between"
                            }, [
                              _createVNode(_component_v_radio, {
                                class: "sublocation-radio",
                                label: loi.text,
                                value: index,
                                onKeyup: _withKeys(($event: any) => (sublocationRadio.value = index), ["enter"])
                              }, null, 8, ["label", "value", "onKeyup"]),
                              _createVNode(_component_info_button, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", {
                                    innerHTML: locationsOfInterestText.value[radio.value][index]
                                  }, null, 8, _hoisted_42)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _cache[143] || (_cache[143] = _createElementVNode("hr", { style: {"border-color":"grey"} }, null, -1)),
            _createElementVNode("div", _hoisted_43, [
              _cache[141] || (_cache[141] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_v_select, {
                modelValue: selectedTimezone.value,
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((selectedTimezone).value = $event)),
                label: "Timezone",
                items: timezoneOptions.value,
                "item-title": "name",
                "item-value": "tz"
              }, null, 8, ["modelValue", "items"]),
              false
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 0,
                    disabled: !highresAvailable.value,
                    modelValue: useHighRes.value,
                    "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((useHighRes).value = $event)),
                    onKeyup: _cache[62] || (_cache[62] = _withKeys(($event: any) => (useHighRes.value = !useHighRes.value), ["enter"])),
                    label: "Use High Resolution Data",
                    color: "#c10124",
                    "hide-details": ""
                  }, null, 8, ["disabled", "modelValue"]))
                : _createCommentVNode("", true),
              (showExtendedRangeFeatures && extendedRangeAvailable.value)
                ? (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: 1,
                    disabled: !extendedRangeAvailable.value,
                    modelValue: showExtendedRange.value,
                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((showExtendedRange).value = $event)),
                    onKeyup: _cache[64] || (_cache[64] = _withKeys(($event: any) => (showExtendedRange.value = !showExtendedRange.value), ["enter"])),
                    label: "Use Extended NO2 range",
                    color: "#c10124",
                    "hide-details": ""
                  }, null, 8, ["disabled", "modelValue"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("article", null, [
              _cache[170] || (_cache[170] = _createElementVNode("h2", null, [
                _createTextVNode("TEMPO NO"),
                _createElementVNode("sub", null, "2"),
                _createTextVNode(" Data")
              ], -1)),
              _cache[171] || (_cache[171] = _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: "https://tempo.si.edu",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, " TEMPO"),
                _createTextVNode(", a collaboration between the Smithsonian and NASA, is the first space-based probe to measure air pollution hourly over North America at neighborhood scales. NO"),
                _createElementVNode("sub", null, "2"),
                _createTextVNode(" (nitrogen dioxide) is one of the pollutants detected by TEMPO. It is produced by wildfires and the burning of fossil fuels. NO"),
                _createElementVNode("sub", null, "2"),
                _createTextVNode(" contributes to the formation of harmful ground-level ozone and toxic particulates in the air we breathe. ")
              ], -1)),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_cds_dialog, {
                  title: "Credits",
                  id: "credits-dialog",
                  modelValue: showCredits.value,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((showCredits).value = $event)),
                  activator: "parent",
                  scrim: false,
                  location: "center center",
                  color: accentColor2.value
                }, {
                  default: _withCtx(() => [
                    _cache[144] || (_cache[144] = _createElementVNode("h4", { class: "mb-2" }, [
                      _createElementVNode("a", {
                        href: "https://tempo.si.edu/",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "TEMPO"),
                      _createTextVNode(" Team Acknowledgments:")
                    ], -1)),
                    _cache[145] || (_cache[145] = _createElementVNode("p", null, " Caroline Nowlan, Aaron Naeger, and Erika Wright provided dates and featured events of interest in the TEMPO data. ", -1)),
                    _cache[146] || (_cache[146] = _createElementVNode("p", null, " Xiong Liu provided the L3 version 2 TEMPO data files. ", -1)),
                    _cache[147] || (_cache[147] = _createElementVNode("p", null, " Heesung Chong provided the shape file for the TEMPO field of regard. ", -1)),
                    _cache[148] || (_cache[148] = _createElementVNode("p", { class: "my-3" }, [
                      _createTextVNode("NASA's Scientific Visualization Studio provided the TEMPO NO"),
                      _createElementVNode("sub", null, "2"),
                      _createTextVNode(" colormap.")
                    ], -1)),
                    _cache[149] || (_cache[149] = _createElementVNode("h4", { class: "mb-2" }, [
                      _createElementVNode("a", {
                        href: "https://www.cosmicds.cfa.harvard.edu/",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "CosmicDS"),
                      _createTextVNode(" Team:")
                    ], -1)),
                    _cache[150] || (_cache[150] = _createTextVNode(" John Lewis", -1)),
                    _cache[151] || (_cache[151] = _createElementVNode("br", null, null, -1)),
                    _cache[152] || (_cache[152] = _createTextVNode(" Jonathan Foster", -1)),
                    _cache[153] || (_cache[153] = _createElementVNode("br", null, null, -1)),
                    _cache[154] || (_cache[154] = _createTextVNode(" Pat Udomprasert", -1)),
                    _cache[155] || (_cache[155] = _createElementVNode("br", null, null, -1)),
                    _cache[156] || (_cache[156] = _createTextVNode(" Jon Carifio", -1)),
                    _cache[157] || (_cache[157] = _createElementVNode("br", null, null, -1)),
                    _cache[158] || (_cache[158] = _createTextVNode(" Alyssa Goodman", -1)),
                    _cache[159] || (_cache[159] = _createElementVNode("br", null, null, -1)),
                    _cache[160] || (_cache[160] = _createTextVNode(" Erika Wright", -1)),
                    _cache[161] || (_cache[161] = _createElementVNode("br", null, null, -1)),
                    _cache[162] || (_cache[162] = _createTextVNode(" Mary Dussault", -1)),
                    _cache[163] || (_cache[163] = _createElementVNode("br", null, null, -1)),
                    _cache[164] || (_cache[164] = _createTextVNode(" Harry Houghton", -1)),
                    _cache[165] || (_cache[165] = _createElementVNode("br", null, null, -1)),
                    _cache[166] || (_cache[166] = _createTextVNode(" Evaluator: Sue Sunbury", -1)),
                    _cache[167] || (_cache[167] = _createElementVNode("br", null, null, -1)),
                    _createVNode(_component_funding_acknowledgement, { class: "my-3" })
                  ]),
                  _: 1
                }, 8, ["modelValue", "color"]),
                _createVNode(_component_cds_dialog, {
                  id: "user-guide-dialog",
                  modelValue: showUserGuide.value,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((showUserGuide).value = $event)),
                  scrim: false,
                  location: "center center",
                  title: "User Guide",
                  color: accentColor2.value
                }, {
                  default: _withCtx(() => [...(_cache[168] || (_cache[168] = [
                    _createElementVNode("p", null, " Do consectetur consequat dolore esse nulla . ", -1),
                    _createElementVNode("p", null, " Reprehenderit sint ipsum laborum in reprehenderit sunt eu pariatur ipsum tempor . ", -1),
                    _createElementVNode("p", null, " Ex laboris fugiat ad duis eu ipsum cupidatat veniam fugiat . ", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "color"]),
                _createVNode(_component_cds_dialog, {
                  id: "about-data-dialog",
                  modelValue: showAboutData.value,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((showAboutData).value = $event)),
                  scrim: false,
                  location: "center center",
                  title: "Data source and processing",
                  "short-title": "About Data",
                  color: accentColor2.value
                }, {
                  default: _withCtx(() => [...(_cache[169] || (_cache[169] = [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This visualization of the TEMPO satellite NO"),
                      _createElementVNode("sub", null, "2"),
                      _createTextVNode(" Tropospheric Column Density data is derived from Level 3 data files obtained from the "),
                      _createElementVNode("a", {
                        href: "https://asdc.larc.nasa.gov/project/TEMPO",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "NASA ASDC TEMPO Data Products Page"),
                      _createTextVNode(". ")
                    ], -1),
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("p", null, [
                      _createTextVNode(" The data has been processed and visualized by the CosmicDS team at the Harvard-Smithsonian Center for Astrophysics. The images displayed have undergone pre-processing to filter out erroneous data, and a 50% cloud cover mask has been applied. For performance optimization, the data resolution has been halved and reprojected to a Web Mercator projection to ensure compatibility with "),
                      _createElementVNode("a", {
                        href: "https://leafletjs.com/",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "Leaflet.js"),
                      _createTextVNode(". ")
                    ], -1),
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("p", null, " The data is rendered using the color map provided by NASA's Scientific Visualization Studio. ", -1),
                    _createElementVNode("br", null, null, -1),
                    _createElementVNode("p", null, [
                      _createTextVNode(" All data processing scripts are available on "),
                      _createElementVNode("a", {
                        href: "https://github.com/johnarban/tempo_processing_scripts",
                        target: "_blank",
                        rel: "noopener noreferrer"
                      }, "GitHub"),
                      _createTextVNode(". ")
                    ], -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue", "color"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _cache[174] || (_cache[174] = _createElementVNode("a", {
            href: "https://www.si.edu/",
            target: "_blank",
            rel: "noopener noreferrer",
            class: "mr-1"
          }, [
            _createElementVNode("img", {
              alt: "Smithsonian Logo",
              src: _imports_1
            })
          ], -1)),
          _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'sciact', 'nasa'] })
        ])
      ]),
      _createVNode(_component_v_dialog, {
        scrim: "false",
        modelValue: showPrivacyDialog.value,
        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((showPrivacyDialog).value = $event)),
        "max-width": "400px",
        id: "privacy-popup-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                  _createTextVNode(" To evaluate usage of this app, ", -1),
                  _createElementVNode("strong", null, "anonymized", -1),
                  _createTextVNode(" data may be collected, including locations viewed and map quiz responses. \"My Location\" data is NEVER collected. ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "pt-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "#BDBDBD",
                    href: "https://www.cfa.harvard.edu/privacy-statement",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, {
                    default: _withCtx(() => [...(_cache[176] || (_cache[176] = [
                      _createTextVNode(" Privacy Policy ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "#ff6666",
                    onClick: _cache[68] || (_cache[68] = () => {
              responseOptOut.value = true;
              showPrivacyDialog.value = false;
            })
                  }, {
                    default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                      _createTextVNode(" Opt out ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    color: "green",
                    onClick: _cache[69] || (_cache[69] = () => {
              responseOptOut.value = false;
              showPrivacyDialog.value = false;
            })
                  }, {
                    default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                      _createTextVNode(" Allow ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (showRating.value)
                ? (_openBlock(), _createBlock(_component_user_experience, {
                    key: 0,
                    id: "rating-root",
                    question: _unref(question),
                    "icon-size": "3x",
                    onDismiss: _cache[74] || (_cache[74] = (_rating, _comments) => {
          showRating.value = false;
        }),
                    onRating: _cache[75] || (_cache[75] = (rating) => {
          currentRating.value = rating;
          updateUserExperienceInfo(currentRating.value, currentComments.value);
        }),
                    onFinish: _cache[76] || (_cache[76] = (rating, comments) => {
          currentRating.value = rating;
          currentComments.value = comments;
          updateUserExperienceInfo(currentRating.value, currentComments.value)
          showRating.value = false;
        })
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_v_btn, {
                          class: "rating-opt-put",
                          color: "#BDBDBD",
                          size: "small",
                          variant: "text",
                          onClick: _cache[71] || (_cache[71] = () => {
                showRating.value = false;
                ratingOptOut.value = true;
              })
                        }, {
                          default: _withCtx(() => [...(_cache[179] || (_cache[179] = [
                            _createTextVNode(" Don't show again ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          class: "privacy-button",
                          color: "#BDBDBD",
                          onClick: _cache[72] || (_cache[72] = ($event: any) => (showRatingPrivacyPolicy.value = true)),
                          onKeyup: _cache[73] || (_cache[73] = _withKeys(($event: any) => (showRatingPrivacyPolicy.value = true), ["enter"])),
                          size: "small",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, {
                          default: _withCtx(() => [...(_cache[180] || (_cache[180] = [
                            _createTextVNode(" What is this? ", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["question"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_cds_privacy_policy, {
            modelValue: showRatingPrivacyPolicy.value,
            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((showRatingPrivacyPolicy).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})